import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/apps/web/layouts/default.vue").then(m => m.default || m))
}